<div class="dialog-shell">
    <div class="dialog-topbar">
        <button mat-icon-button mat-dialog-close class="button-close--outlined dialog-close" color="primary" aria-label="Chiudi">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-head">
        <h1 mat-dialog-title class="dialog-title">Modifica Profilo</h1>
        <p class="dialog-subtitle">Aggiorna i tuoi dati personali e i recapiti con cui possiamo contattarti.</p>
    </div>

    <div mat-dialog-content class="dialog-body">
        <form [formGroup]="formGroup" (ngSubmit)="onYesClick()" class="dialog-form">
            <div class="form-sections">
                <section class="form-section">
                    <h2 class="section-title">Dati personali</h2>

                    <div class="form-grid">
                        <mat-form-field class="fo-field">
                            <mat-label>Nome</mat-label>
                            <input matInput type="text" formControlName="name" autocomplete="given-name" required />
                            <mat-icon matSuffix>face</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup.controls['name'].hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup.controls['name'].hasError('alphabeticOnly')"
                                >Numeri non permessi</mat-error
                            >
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Cognome</mat-label>
                            <input matInput type="text" formControlName="surname" autocomplete="family-name" required />
                            <mat-icon matSuffix>face</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup.controls['surname'].hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup.controls['surname'].hasError('alphabeticOnly')"
                                >Numeri non permessi</mat-error
                            >
                        </mat-form-field>
                    </div>
                </section>

                <section class="form-section">
                    <h2 class="section-title">Contatti</h2>

                    <div class="form-grid">
                        <mat-form-field class="fo-field">
                            <mat-label>Indirizzo e-mail</mat-label>
                            <input matInput type="text" formControlName="email" autocomplete="email" required />
                            <mat-icon matSuffix>mail_outline</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup.controls['email'].hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup.controls['email'].hasError('email_custom')"
                                >Formato Mail errato</mat-error
                            >
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Telefono</mat-label>
                            <input matInput type="text" formControlName="phone" autocomplete="tel" required />
                            <mat-icon matSuffix>local_phone</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup.controls['phone'].hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup.controls['phone'].hasError('numericOnly')"
                                >Lettere non permesse</mat-error
                            >
                        </mat-form-field>
                    </div>
                </section>

                <section class="form-section">
                    <h2 class="section-title">Informazioni aggiuntive</h2>

                    <div class="form-grid">
                        <mat-form-field class="fo-field">
                            <mat-label>Sesso</mat-label>
                            <mat-select formControlName="gender" required>
                                <mat-option *ngFor="let sex of gender" [value]="sex.id">
                                    {{ sex.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="error-message" *ngIf="formGroup.controls['gender'].hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Regione</mat-label>
                            <mat-select formControlName="id_region" required>
                                <mat-option *ngFor="let region of regions" [value]="region.id">
                                    {{ region.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="error-message" *ngIf="formGroup?.get('id_region').hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                        </mat-form-field>
                    </div>
                </section>
            </div>

            <div class="dialog-footer">
                <button type="submit" class="fo-btn fo-btn--primary fo-btn--block" [disabled]="!formGroup.valid">Procedi</button>
            </div>
        </form>
    </div>
</div>
